import Axios, { CancelTokenSource, AxiosError } from 'axios';
import AxiosHelper from 'services/AxiosHelper';
import { Item } from 'shared/components/hawksearch/models/Recommendation';
import { Result } from 'shared/components/hawksearch/models/Search';
import { CompareResultObject } from '../../../models/CompareResultObject';

export interface ProductPriceAndAvailability {
	sku: string;
	price: string;
	outOfStock: boolean;
}

export interface ProductPriceResponse {
	productsPrices: ProductPriceAndAvailability[];
}

// Gets prices for items on PLP
export const GetProductsPriceDetails = async (results: Result[]) => {
	if (results.length === 0) {
		return null;
	}

	let itemSkus: string[] = [];
	results.forEach((item) => {
		if (item.getDocumentValue('product_sku')) {
			itemSkus.push(item.getDocumentValue('product_sku') ?? '');
		}
	});

	itemSkus = itemSkus.filter((i) => i !== '');
	return await SendRequest(itemSkus);
};

// Gets prices for recommendation items
export const GetProductComparisonPriceDetails = async (results: CompareResultObject[]) => {
	if (results.length === 0) {
		return null;
	}

	let itemSkus: string[] = [];
	results.forEach((item) => {
		const field = item.Document.find((item) => item.Field === 'product_sku');

		if (field && field.Value.length > 0) {
			itemSkus.push(field.Value[0] ?? '');
		}
	});

	itemSkus = itemSkus.filter((i) => i !== '');
	return await SendRequest(itemSkus);
};

// Gets prices for recommendation items
export const GetRecommendationProductsPrice = async (results: Item[]) => {
	if (results.length === 0) {
		return null;
	}

	let itemSkus: string[] = [];
	results.forEach((item) => {
		itemSkus.push(item.sku ?? '');
	});

	itemSkus = itemSkus.filter((i) => i !== '');
	return await SendRequest(itemSkus);
};

const SendRequest = async (itemSkus: string[]) => {
	const requestToken: CancelTokenSource = Axios.CancelToken.source();
	try {
		const response = await AxiosHelper.post<ProductPriceResponse>('/ajax/hawksearch/products-price', {
			itemSkus,
			cancelToken: requestToken.token,
		});
		return response?.data;
	} catch (error) {
		const axiosError = error as AxiosError;
		console.error(`An error occurred while loading pricing organization: ${axiosError.message}`);
		return undefined;
	}
};
